<div class="dx-field">
  <div class="dx-field-label" style='width: 170px'>Requisition Status</div>
  <div class="dx-field-value">
    <dx-radio-group
      [items]="status"
      [(value)]="selected"
      (onValueChanged)="valueChanged()"
      layout="horizontal">
    </dx-radio-group>
  </div>
</div>
